import { combineReducers } from "@reduxjs/toolkit";
import GroupTemplate from "./GroupTemplateSlice";
import TemplateAddCustomersPacksSlice from "./TemplateAddCustomersPacksSlice";
import TemplateAvailableCustomers from "./TemplateAvailableCustomersSlice";
import TemplateAvailablePacksSlice from "./TemplateAvailablePacksSlice";
import TemplateContentFiltersSlice from "./TemplateContentFiltersSlice";
import TemplateContentSlice from "./TemplateContentSlice";
import TemplateCustomers from "./TemplateCustomersSlice";
import TemplateFiltersSlice from "./TemplateFiltersSlice";
import TemplateOverview from "./TemplateOverviewSlice";
import TemplateOwners from "./TemplateOwnersSlice";
import TemplatePacksSlice from "./TemplatePacksSlice";

const content = combineReducers({
  content: TemplateContentSlice,
  filters: TemplateContentFiltersSlice,
});

export const GroupTemplateReducer = combineReducers({
  base: GroupTemplate,
  availableCustomers: TemplateAvailableCustomers,
  owners: TemplateOwners,
  customers: TemplateCustomers,
  overview: TemplateOverview,
  filters: TemplateFiltersSlice,
  content,
  availablePacks: TemplateAvailablePacksSlice,
  packs: TemplatePacksSlice,
  addCustomersPacks: TemplateAddCustomersPacksSlice,
});

export type GroupTemplateState = ReturnType<typeof GroupTemplateReducer>;
